(() => {
  const button = document.querySelector('[data-back-to-top]');
  if (!button) return;

  const circle = button.querySelector('.btt-circle');
  if (!circle || !('r' in circle)) return;

  const parseDataNumber = (value, fallback) => {
    const parsedValue = Number.parseInt(value ?? '', 10);
    return Number.isNaN(parsedValue) ? fallback : parsedValue;
  };

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  const radius = circle.r.baseVal.value;
  const circumference = 2 * Math.PI * radius;
  circle.style.strokeDasharray = `${circumference} ${circumference}`;

  const showAfter = parseDataNumber(button.dataset.showAfter, 300);
  const scrollDepth = parseDataNumber(button.dataset.scrollDepth, 600);
  const reducedMotionQuery = window.matchMedia?.(
    '(prefers-reduced-motion: reduce)',
  );
  const scrollBehavior =
    reducedMotionQuery?.matches || button.dataset.scrollBehavior === 'auto'
      ? 'auto'
      : 'smooth';

  const setProgress = (progress) => {
    const normalizedProgress = clamp(progress, 0, 1);
    const offset = circumference * (1 - normalizedProgress);
    circle.style.strokeDashoffset = `${offset}`;
  };

  let isTicking = false;

  const update = () => {
    const scrollTop = window.scrollY || window.pageYOffset;
    const doc = document.documentElement;
    const bodyScrollHeight = document.body?.scrollHeight ?? 0;
    const scrollHeight = Math.max(bodyScrollHeight, doc.scrollHeight);
    const maxScroll = scrollHeight - doc.clientHeight;
    const effectiveShowAfter = Math.min(
      showAfter,
      Math.max(0, maxScroll * 0.5),
    );
    const progress = maxScroll > 0 ? scrollTop / maxScroll : 0;

    setProgress(progress);

    const isVisible = scrollTop >= effectiveShowAfter;
    button.classList.toggle('btt--visible', isVisible);
    button.setAttribute('aria-hidden', isVisible ? 'false' : 'true');

    button.classList.toggle('btt--scrolled', scrollTop > scrollDepth);

    isTicking = false;
  };

  const onScrollOrResize = () => {
    if (isTicking) return;
    isTicking = true;
    window.requestAnimationFrame(update);
  };

  button.addEventListener('click', (event) => {
    event.preventDefault();
    window.scrollTo({ top: 0, behavior: scrollBehavior });
  });

  button.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    event.preventDefault();
    button.click();
  });

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  setProgress(0);
  update();
})();
